export * from "./tiledPlaneBuilder.pure";

import { RegisterTiledPlaneBuilder } from "./tiledPlaneBuilder.pure";
RegisterTiledPlaneBuilder();
